module.exports = __webpack_public_path__ + "static/media/Line-Up_bulk_upload_template.a6d8d41a.csv";